import { render, staticRenderFns } from "./BillingDetailsModal.vue?vue&type=template&id=771f2a83&"
import script from "./BillingDetailsModal.vue?vue&type=script&lang=js&"
export * from "./BillingDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports